import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var SharedItem = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment sharedItems on ComponentSharedItem {\n    title\n    description\n    image {\n      src\n      alt\n      width\n      height\n    }\n    link {\n      text\n      href\n    }\n  }\n"])));
export default SharedItem;